import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
//@ts-expect-error
import useDebouncedEffect from 'use-debounced-effect';
import networkConstant from '../../../constants/network.constant';
import { State } from '../../../reducers';
import { PoolType, StakingPool } from '../../../services/staking/staking.types';
import { NetworkId } from '../../../types/network.types';

interface Props {
  networkIds: NetworkId[];
  poolType: PoolType;
  searchTerm: string;
  showClosed: boolean;
}

//@TODO would be good to move this all to redux with redux-thunk
export function useStakingPools({ networkIds, poolType, searchTerm, showClosed }: Props) {
  const [loading, setLoading] = useState(false);
  const [stakingPools, setStakingPools] = useState<StakingPool[]>();

  const StakingPoolState = useSelector((state: State) => state.StakingPools);

  function getData() {
    setLoading(true);
    try {
      let data: StakingPool[] = StakingPoolState;

      if (networkIds && !_.isEqual(networkIds, [1, 56, 97])) {
        if (_.isEqual(networkIds, [1])) {
          data = data.filter(
            (pool) =>
              networkIds.includes(pool.networkId) ||
              pool.networkId === networkConstant.networkId.ethKovan ||
              pool.networkId === networkConstant.networkId.ethRinkeby,
          );
        } else {
          data = data.filter((pool) => networkIds.includes(pool.networkId));
        }
      }

      if (showClosed) {
        data = data.filter((pool) => pool.finished === true);
      } else {
        data = data.filter((pool) => !pool.finished);
      }

      if (poolType) {
        data = data.filter((pool) => poolType === pool.poolType);
      }
      if (searchTerm) {
        data = data.filter((pool) =>
          pool.stakingTokenSymbol.toLocaleLowerCase().includes(searchTerm.toLowerCase()),
        );
      }

      setStakingPools(data);
    } catch (error) {
      // @TODO handle error
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, [networkIds, poolType, showClosed]);

  //useDebouncedEffect(getData, 250, [searchTerm]);
  useDebouncedEffect(getData, 250, [poolType, networkIds]);

  return { loading, stakingPools };
}
